module.exports = __webpack_public_path__ + "static/media/IMG_7738.4b911637.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/IMG_7738.png
// module id = 45
// module chunks = 0